import React from "react";
import PubSub from 'pubsub-js';

import { AppContext } from '../util';
import { LOAD_START, LOAD_END } from '../events';

class Onboarding extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            isLoading: false
        };
    }
    
    componentDidMount() {
        PubSub.subscribe(LOAD_START, () => this.setState({isLoading: true}));
        PubSub.subscribe(LOAD_END, () => this.setState({isLoading: false}));
    }

    render() {

        const className = this.state.isLoading ? 'loader__outer' : 'loader__outer loader__outer--hidden';

        return (
            <div className={className}>
                <div className="loader"></div>
            </div>
        )
    }
}

export default Onboarding;